import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { ToolFieldRows } from "web_myplann/Portfolio/Components/Redesign/Detail/FundDetail/ToolFieldRows";
import type { NormalizedTool } from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { useToolSummary } from "web_myplann/Portfolio/Helpers/useToolSummary";

type Props = {
	tool: NormalizedTool;
	currencySign: string;
	toolsSummary?: Parameters<typeof useToolSummary>[1];
};

export const ToolDetailCard: FC<Props> = ({
	tool,
	currencySign,
	toolsSummary,
}) => {
	const { t } = useResource();
	const { totalValue, totalInvested } = useToolSummary(tool.id, toolsSummary);

	return (
		<DetailCard label={t(Resources.DataCard.BasicInfo.title)}>
			<ToolFieldRows
				tool={tool}
				currencySign={currencySign}
				totalValue={totalValue}
				totalInvested={totalInvested}
			/>
		</DetailCard>
	);
};
